<template>
	<div class="album-container">
		<a-spin :spinning="loading">
			<div class="album-main">
				<div class="album-thumbnail">
					<div class="album-thumbnail_list">
						<div class="album-thumbnail_item_box" :class="{ 'selected-page': curPage === index + 1 }" v-for="(item, index) in pageViewList" :key="`thumbnail_${item.id}`">
							<span class="album-thumbnail_item" :class="{ 'selected-page': curPage === index + 1 }" :style="getBgStyle(item.background_image.thumbnail_url)" @click="pageChange(index)" @contextmenu.prevent="showRightMenu($event, item)">
								<i>{{ index + 1 }}</i>
							</span>
						</div>
					</div>
				</div>
				<div class="album-content">
					<div v-for="(pageView, page) in pageViewList" :key="pageView.id" class="album-item"
						:style="getPageStyle(pageView)" v-if="curPage === page + 1">
						<div v-for="section in pageView.section_views" :key="section.template_section_id">
							<div v-for="fieldView in section.field_views" :key="fieldView.template_field_id">
								<div v-if="fieldView.type === 'text'" class="album-item_field"
									:style="getFieldStyle(pageView, fieldView)"
									@click="fieldClickHandle(pageView, section, fieldView)">{{ getFieldValue(fieldView) }}</div>
								<div v-else class="album-item_field" :style="getFieldStyle(pageView, fieldView)"
									@contextmenu.prevent="showImageRightMenu($event, pageView, fieldView)"
									@click="fieldClickHandle(pageView, section, fieldView)">
									{{ getFieldValue(fieldView) }}
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="album-sider scroll-bar">
					<span class="album-sider_name m-bottom-30">{{ klassInfo.name }}-{{ studentInfo.kid_name }}</span>
					<div class="album-sider_label">
						<span>手册名称</span>
						<svg-icon v-if="canSubmitStatus" class="album-sider_edit" iconClass="edit"
							@click="updateHandle"></svg-icon>
					</div>
					<a-textarea ref="nameRef" v-if="nameEditStatus" v-model="albumTitle" placeholder="请输入内容"
						:auto-size="{ minRows: 3 }" style="resize: none" @blur="onBlurHandle" />
					<span class="album-sider_name" v-else>{{ albumInfo.title }}</span>
					<div v-if="!canSubmitStatus" :class="['album-sider_status', `ALBUM_STATUS_${albumInfo.status}`]">
						<span>{{ ALBUM_DIGTAL_STATUS[albumInfo.status] }}</span>
						<svg-icon v-if="albumInfo.status === 'GENERATED'" class="cursour" iconClass="download"
							@click="downloadHandle"></svg-icon>
					</div>
					<div style="height: 1px;">
						<a-divider class="album-sider_divider"></a-divider>
					</div>
					<div v-if="fieldView && fieldView.type === 'text' && isLeftClick">
						<span class="album-sider_label">文本内容</span>
						<a-textarea v-model="fieldView.value" placeholder="请输入内容" :auto-size="{ minRows: 3 }"
							style="resize: none" @blur="updatePageHandle()" />
						<span class="album-sider_label">字体大小</span>
						<a-slider v-model="fieldView.style.font_size" :min="10" :max="100" @blur="updatePageHandle()" />
						<a class="m-top-10 album-sider_select" href="javascript:;" @click="selectHandle">从班级圈选择>></a>
					</div>
					<div v-if="fieldView && fieldView.type === 'image' && isLeftClick">
						<span class="album-sider_label">图片编辑</span>
						<img v-if="fieldView.image" class="album-sider_image cursour" @click="viewPhoto" :src="fieldView.image.url" />
						<a-upload v-else :customRequest="event => customRequest(event, 'background_image_url')"
							list-type="picture-card" :show-upload-list="false">
							<div class="album-sider_image">
								<svg-icon iconClass="plus"></svg-icon>
							</div>
						</a-upload>
						<a class="m-top-10 album-sider_select" href="javascript:;" @click="selectHandle">从班级圈选择>></a>
						<a-upload v-if="fieldView.image" :customRequest="event => customRequest(event, 'background_image_url')"
							list-type="picture-card" :show-upload-list="false">
							<a class="m-top-10 album-sider_select" href="javascript:;">上传本地图片</a>
						</a-upload>
					</div>

					<span class="flex-empty"></span>

					<a-button v-if="canSubmitStatus" type="primary" class="album-sider_confirm"
						@click="updateAlbumStatus">定稿</a-button>
				</div>
			</div>
		</a-spin>

		<RightMenu v-if="menuSetting.status" :modelValue.sync="menuSetting" :data="menuList"></RightMenu>

		<RightMenu v-if="imageMenuSetting.status" :modelValue.sync="imageMenuSetting" :data="imageMenuList"></RightMenu>

		<a-modal title="图片编辑" v-model="imageModalInfo.visible" :confirm-loading="imageModalInfo.loading" :width="800"
			centered destroyOnClose>
			<div class="album-editor">
				<image-editor :klassId="klassId" :image-url="imageUrl" :scale="imageModalInfo.scale"
					@cropperHandle="cropperHandle" />
			</div>
			<template slot="footer">
				<div></div>
			</template>
		</a-modal>

		<a-modal :title="modalInfo.title" v-model="modalInfo.visible" :confirm-loading="modalInfo.loading" :width="800"
			:bodyStyle="{ background: '#f5f5f5' }" centered destroyOnClose>
			<modal-klass-circle :klassId="klassId" :fieldType="fieldType" :selectedView.sync="selectedView" />
			<template slot="footer">
				<div>
					<a-button @click="cancelHandle">取消</a-button>
					<a-button type="primary" :disabled="!selectedView.length" @click="okHandle">确定</a-button>
				</div>
			</template>
		</a-modal>
		
		<app-view-img :imageList.sync="imageList" :imageIndex.sync="imageIndex" />
	</div>
</template>

<script>
import AppViewImg from "@/components/AppViewImg"
import AlbumService from "@/api/albumService"
import KlassService from "@/api/klassService"
import StudentService from "@/api/studentService"
import RightMenu from "@/components/rightMenu"
import ImageEditor from "./imageEditor"
import modalKlassCircle from "./modalKlassCircle.vue"
import { uploadHandle } from "@/utils"
import dict from "@/config"
export default {
  name: "album",
  components: { RightMenu, ImageEditor, modalKlassCircle, AppViewImg },
  data() {
    return {
      imageList: [],
      imageIndex: 0,
      ALBUM_DIGTAL_STATUS: dict.ALBUM_DIGTAL_STATUS,
      klassId: undefined,
      albumId: undefined,
      pageViewList: [],
      ratio: 1,
      curPage: 1,
      loading: false,
      klassInfo: {},
      studentInfo: {},
      albumInfo: {},
      menuSetting: {
        status: false,
        x: 0,
        y: 0
      },
      imageMenuSetting: {
        status: false,
        x: 0,
        y: 0
      },
      menuList: [
        {
          name: "复制",
          click: () => {
            this.updateAlbumBodyHandle("copy")
          }
        },
        {
          name: "删除",
          click: () => {
            const filterPage = this.pageViewList.filter(item => item.template_page_id === this.childPageView.template_page_id)
            if (filterPage.length === 1) {
              this.$message.warning("已经是唯一模板了，不能删除")
              return
            }
            this.updateAlbumBodyHandle("del")
          }
        }
      ],
      imageMenuList: [
        {
          name: "图片编辑",
          click: () => {
            this.imageModalInfo.visible = true
            this.imageModalInfo.scale = this.fieldView.width / this.fieldView.height
            this.$nextTick(() => {
              setTimeout(() => {
                this.imageUrl = this.fieldView.image.url
              }, 500)
            })
          }
        },
        {
          name: "删除",
          click: () => {
            this.updatePageHandle("del")
          }
        }
      ],
      pageView: null,
      childPageView: null,
      fieldView: null,
      sectionView: [],
      isLeftClick: false,
      fontSize: 0,
      imageModalInfo: {
        visible: false,
        loading: false,
        scale: 1
      },
      imageUrl: "",
      modalInfo: {
        title: "从班级圈获取图片",
        visible: false,
        loading: false
      },
      fieldType: "text",
      selectedView: [],
      imageLen: 1,
      nameEditStatus: false
    }
  },
  computed: {
    getBgStyle() {
      return function(thumbnail_url) {
        return {
          background: `url(${thumbnail_url}) no-repeat center center`,
          "background-size": "cover"
        }
      }
    },
    getContinerStyle() {
      let styleObj = {
        width: this.pageViewList.length * 375 + "px",
        transform: `translate3d(-${(this.curPage - 1) * 375}px, 0, 0)`
      }
      return styleObj
    },
    getPageStyle() {
      return function(pageView) {
        const { width, height, background_image } = pageView
        const _height = document.querySelector(".album-content").offsetHeight
        const _ratio = (_height - 100) / height
        return {
          position: "relative",
          width: `${width * _ratio}px`,
          height: `${height * _ratio}px`,
          backgroundColor: "#f0f2f5",
          backgroundImage: `url(${background_image.url})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundSize: "cover"
        }
      }
    },
    getFieldStyle() {
      return function(pageView, fieldView) {
        const _height = document.querySelector(".album-content").offsetHeight
        const _ratio = (_height - 100) / pageView.height
        const { width, height, top, left, type, style, value, image } = fieldView
        const { alignment, font_color, font_size, font_weight, line_height, rotate, border_color, border_radius, border_with } = style
        let styleObj = {
          position: "absolute",
          top: `${top * _ratio}px`,
          left: `${left * _ratio}px`,
          width: `${width * _ratio}px`,
          height: `${height * _ratio}px`,
          color: "#999999",
          overflow: "hidden",
          textAlign: "justify",
          transform: `rotate(${rotate || 0}deg)`
        }
        if (type === "text") {
          styleObj = {
            ...styleObj,
            fontSize: `${font_size * _ratio}px`,
            lineHeight: line_height,
            font_weight,
            wordBreak: "break-all",
            whiteSpace: "pre-wrap"
          }

          if (value && value.length) {
            styleObj.color = font_color ? `#${font_color.toString(16).slice(2)}` : "#515151"
          }

          styleObj.display = "flex"
          styleObj.flexFlow = "wrap row"
          if (alignment.startsWith("center")) {
            styleObj.alignItems = "center"
          } else if (alignment.startsWith("top")) {
            styleObj.alignItems = "flex-start"
          } else if (alignment.endsWith("bottom")) {
            styleObj.alignItems = "flex-end"
          }

          if (alignment.endsWith("center")) {
            styleObj.justifyContent = "center"
          } else if (alignment.endsWith("Right")) {
            styleObj.justifyContent = "flex-end"
          } else if (alignment.endsWith("Left")) {
            styleObj.justifyContent = "flex-start"
          }
          return styleObj
        }
        if (image) {
          Object.assign(styleObj, {
            backgroundImage: `url(${image.compressed_url})`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundSize: "cover"
          })
        } else {
          styleObj.textAlign = "center"
          styleObj.lineHeight = `${height * _ratio}px`
        }

        if (border_with) {
          style.border = `${border_with}px solid #${border_color.toString(16)}`
        }

        if (border_radius) {
          styleObj.borderRadius = `${border_radius * _ratio}px`
        }
        return styleObj
      }
    },

    getFieldValue() {
      return function(fieldView) {
        const { type, value, image, placeholder } = fieldView
        if (type === "image") {
          return image ? "" : placeholder || "请点击选择图片"
        }
        if (value && value.trim().length) {
          return value
        }
        return placeholder || "请点击输入文字"
      }
    },

    canSubmitStatus() {
      const statusArr = Object.keys(dict.ALBUM_STATUS)
      return statusArr.includes(this.albumInfo.status)
    }
  },
  mounted() {
    this.initHandle()
  },
  methods: {
    initHandle() {
      this.klassId = this.$route.query.klass_id
      this.albumId = this.$route.query.id
      this.getKlassInfo()
      this.getStudentInfo()
      this.getAlbumHandle()
      this.getAlbumBodyHandle()
    },
    getKlassInfo() {
      KlassService.getKlassInfoService({ klassId: this.klassId }).then(res => {
        this.klassInfo = res
      })
    },

    getStudentInfo() {
      StudentService.getStudentService({
        studentId: this.$route.query.student_id
      }).then(res => {
        this.studentInfo = res
      })
    },

    getAlbumHandle() {
      AlbumService.getAlbumService({ albumId: this.albumId }).then(res => {
        this.albumInfo = res
      })
    },
    getAlbumBodyHandle() {
      this.loading = true
      AlbumService.getAlbumBodyService({ albumId: this.albumId })
        .then(res => {
          const pageViewList = res.page_views || []
          this.ratio = 375 / pageViewList[0].width
          this.curPage = Math.min(this.curPage, pageViewList.length)
          this.pageViewList = pageViewList
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    pageChange(index) {
      this.curPage = index + 1
      this.isLeftClick = false
    },

    showRightMenu(e, pageView) {
      if (!this.canSubmitStatus) return
      Object.assign(this.menuSetting, {
        status: true,
        x: e.clientX,
        y: e.clientY
      })
      this.childPageView = pageView
    },

    showImageRightMenu(e, pageView, fieldView) {
      if (!this.canSubmitStatus) return
      if (!fieldView.image) {
        return
      }
      Object.assign(this.imageMenuSetting, {
        status: true,
        x: e.clientX,
        y: e.clientY
      })
      this.isLeftClick = false
      this.pageView = pageView
      this.fieldView = fieldView
    },

    fieldClickHandle(pageView, sectionView, fieldView) {
      if (!this.canSubmitStatus) return
      this.pageView = pageView
      this.fieldView = fieldView
      this.sectionView = sectionView
      this.isLeftClick = true
      if (fieldView.type === "image") {
        this.imageModalInfo.scale = this.fieldView.width / this.fieldView.height
      }
    },

    updateAlbumBodyHandle(type) {
      const pageViewList = [...this.pageViewList]
      const index = pageViewList.findIndex(item => item.id === this.childPageView.id)
      if (type === "del") {
        pageViewList.splice(index, 1)
      } else {
        pageViewList.splice(index + 1, 0, { isCopy: true, ...this.childPageView })
      }
      const pageViews = []
      for (let i = 0; i < pageViewList.length; i++) {
        pageViews.push({ ...this.getAlbumPageParams(pageViewList[i]), id: i + 1 })
      }

      this.$confirm({
        title: "提示信息",
        content: type === "del" ? "是否删除当前页" : "是否复制当前页",
        okText: "确定",
        cancelText: "取消",
        onOk: () => {
          return new Promise((resolve, reject) => {
            this.loading = true
            AlbumService.updateAlbumBodyService({ albumId: this.albumId, albumBody: { pages: pageViews } })
              .then(() => {
                this.loading = false
                this.getAlbumBodyHandle()
                resolve()
              })
              .catch(() => {
                reject()
                this.loading = false
                this.$message.error("操作失败，请重新操作")
              })
          })
        }
      })
    },

    updatePageHandle(type) {
      this.loading = true
      if (type === "del") {
        this.$confirm({
          title: "删除图片",
          content: "是否删除此图片",
          okText: "确定",
          cancelText: "取消",
          onOk: () => {
            this.fieldView.image = null
            return new Promise((resolve, reject) => {
              AlbumService.updateAlbumBodyPageService({ albumId: this.albumId, ...this.getAlbumPageParams(this.pageView) })
                .then(() => {
                  this.loading = false
                  this.getAlbumBodyHandle()
                  resolve()
                })
                .catch(() => {
                  this.loading = false
                  this.$message.error("操作失败，请重新操作")
                  reject()
                })
            })
          }
        })
      } else {
        AlbumService.updateAlbumBodyPageService({ albumId: this.albumId, ...this.getAlbumPageParams(this.pageView) })
          .then(() => {
            this.loading = false
            if (type === "image") {
              this.getAlbumBodyHandle()
            }
            this.$message.success("操作成功")
          })
          .catch(() => {
            this.loading = false
            this.$message.error("操作失败，请重新操作")
          })
      }
    },

    getAlbumPageParams(pageSource) {
      const { section_views, background_image, isCopy, ...others } = JSON.parse(JSON.stringify(pageSource))
      const pageView = { ...others, sections: [] }
      pageView.background_image_id = background_image.id
      for (let i = 0; i < section_views.length; i++) {
        const { template_section_id, field_views } = section_views[i]
        const fields = []
        for (let j = 0; j < field_views.length; j++) {
          const fieldView = field_views[j]
          if (fieldView.type === "text") {
            isCopy && (fieldView.value = null)
            fields.push(fieldView)
            continue
          }
          if (!fieldView.image) {
            fieldView.image_id = null
          } else {
            fieldView.image_id = fieldView.image.id
          }
          delete fieldView.image

          isCopy && (fieldView.image_id = null)
          fields.push(fieldView)
        }
        pageView.sections.push({ template_section_id, fields })
      }

      return pageView
    },

    customRequest(event) {
      this.loading = true
      uploadHandle({ file: event.file, klassId: this.klassId }, "album")
        .then(imageObj => {
          this.fieldView.image = imageObj
          this.updatePageHandle("image")
        })
        .catch(() => {
          this.loading = false
        })
    },

    selectHandle() {
      this.selectedView = []
      let title = "从班级圈获取内容"
      if (this.fieldView.type === "image") {
        title = "从班级圈获取图片"
      }
      this.fieldType = this.fieldView.type
      this.modalInfo = {
        visible: true,
        loading: false,
        title
      }
    },

    cancelHandle() {
      this.modalInfo.visible = false
    },

    okHandle() {
      this.loading = true
      if (this.fieldView.type === "text") {
        this.fieldView.value = `${this.selectedView[0].tags.map(item => "#" + item.name).join(",")} ${this.selectedView[0].content}`
        this.updatePageHandle()
      } else {
        this.fieldView.image = this.selectedView[0]
        this.updatePageHandle("image")
      }
      this.modalInfo.visible = false
    },

    updateAlbumStatus() {
      AlbumService.updateAlbumStatusService({ albumId: this.albumId })
        .then(() => {
          this.$message.success("定稿成功")
        })
        .catch(() => {
          this.$message.error("操作失败，请检查后重试")
        })
    },

    updateAlbumInfoHandle() {
      if (!this.albumTitle || !this.albumTitle.trim().length) {
        this.$message.warning("请输入手册名称")
        return
      }

      AlbumService.updateAlbumService({
        title: this.albumTitle.trim(),
        albumId: this.albumInfo.id
      })
        .then(() => {
          this.$message.success("操作成功")
          this.nameEditStatus = false
          this.albumInfo.title = this.albumTitle.trim()
        })
        .catch(() => {
          this.$message.error("操作失败，请重新操作")
        })
    },

    updateHandle() {
      this.nameEditStatus = true
      this.albumTitle = this.albumInfo.title
      this.$nextTick(() => {
        this.$refs.nameRef.focus()
      })
    },
    onBlurHandle() {
      if (this.albumTitle !== this.albumInfo.title) {
        this.updateAlbumInfoHandle()
      } else {
        this.nameEditStatus = false
      }
    },

    cropperHandle(source) {
      this.loading = true
      this.imageModalInfo.visible = false
      this.fieldView.image = source
      this.updatePageHandle("image")
    },

    downloadHandle() {
      window.open(this.albumInfo.digital_copy.url, "_blank")
    },

    viewPhoto() {
      const imageList = []
      for (let i = 0; i < this.pageView.section_views.length; i++) {
        for (let j = 0; j < this.pageView.section_views[i].field_views.length; j++) {
          const { type, image } = this.pageView.section_views[i].field_views[j]
          if (type === "image" && image) {
            imageList.push(image.url)
          }
        }
      }

      this.imageList = imageList
      this.imageIndex = this.imageList.findIndex(item => item === this.fieldView.image.url)
    }
  }
}
</script>

<style lang="less" scoped>
.album {
  &-container {
    min-width: 980px;

    /deep/.ant-upload {
      display: block;
      margin: 0;
      padding: 0 !important;
      border: none;

      &:hover {
        border: none;
      }
    }

    /deep/.ant-upload-picture-card-wrapper {
      display: block;
      // height: 120px;
    }

    /deep/.ant-upload-select-picture-card {
      height: auto;
      background: transparent;
    }
  }

  &-main {
    display: flex;
    flex-flow: nowrap row;
    height: calc(100vh - 150px);
    padding-bottom: 20px;
    margin: 15px 100px 0 0;
  }

  &-thumbnail {
    width: 165px;
    background: #e9e9e9;
    overflow-x: hidden;

    &_list {
      width: 185px;
      height: 100%;
      overflow: auto;
    }

    &_item {
      display: block;
      width: 107px;
      height: 143px;
      line-height: 143px;
      cursor: pointer;
      background-size: cover !important;
      font-size: 12px;
      border: 1px solid transparent;
      // box-shadow: 0 4px 12px rgb(0 0 0 / 15%);
      &_box {
        width: 111px;
        margin: 17px 0 17px 33px;
        border: 2px solid transparent;
        &.selected-page {
          border: 2px solid rgba(183, 71, 42, 0.9);
        }
      }

      i {
        margin-left: -20px;
        color: #343c6a;
      }

      &.selected-page {
        border: 1px solid white;
      }
    }
  }

  &-content {
    flex-grow: 1;
  }

  &-sider {
    display: flex;
    flex-flow: nowrap column;
    width: 240px;
    margin: 20px 0 0 20px;
    padding: 10px 27px 20px 17px;
    background: #fff;
    overflow-x: hidden;
    overflow-y: auto;

    &_name {
      display: block;
      color: #3d3d3d;
      font-weight: bold;
      font-size: 14px;
    }

    &_label {
      display: block;
      margin: 15px 0;
      color: #343c6a;
      font-size: 14px;
    }

    &_select {
      display: block;
      color: #01acfc;
    }

    &_edit {
      font-size: 14px;
      float: right;
      cursor: pointer;
    }

    &_image {
      display: block;
      width: 206px;
      // height: 120px;
      border-radius: 4px;
      background: #ececee;
      font-size: 40px;
      line-height: 120px;
      background-size: cover !important;
    }

    &_divider {
      width: calc(100% + 44px);
      margin: 10px -27px 10px -17px;
      background: #d9d9d9;
    }

    &_confirm {
      width: 200px;
      margin-top: 20px;
      // position: fixed;
      // bottom: 70px;
    }

    &_status {
      display: flex;
      flex-flow: nowrap row;
      align-items: center;
      justify-content: space-between;
      margin: 15px 0;
      font-weight: bold;
      font-size: 14px;
    }
  }

  &-item {
    position: relative;
    display: block;
    margin: 50px auto;
    background-size: cover !important;

    &_field {
      border: 1px dashed #999;
      cursor: pointer;
    }
  }

  &-editor {
    height: 600px;
  }
}

#album {
  width: 375px;
  margin: 50px 100px 30px;
  overflow: hidden;
}
</style>
